/**
 * Retenir la page en cours d'une story, pour y revenir après un lien.
 *
 * Un lien posé dans une story s'ouvre dans le même onglet. La page lue est notée dans le
 * stockage de l'onglet, et relue seulement quand le lecteur arrive par un retour arrière :
 * un rechargement ou un nouveau scan repartent du début.
 */
class ResumeUtilsWrapper {

    remember(storyId: number | string, routeId: string): void {
        try {
            window.sessionStorage.setItem(this.key(storyId), routeId);
        } catch {
            // Stockage refusé (navigation privée, quota) : on se passe de la reprise.
        }
    }

    recall(storyId: number | string): string | null {
        if (!this.cameBack()) {
            return null;
        }
        try {
            return window.sessionStorage.getItem(this.key(storyId));
        } catch {
            return null;
        }
    }

    private key(storyId: number | string): string {
        return `qezako.story.${storyId}.page`;
    }

    // Vrai quand la page a été atteinte par le bouton « précédent » ou « suivant » du navigateur.
    private cameBack(): boolean {
        if (typeof performance === "undefined" || typeof performance.getEntriesByType !== "function") {
            return false;
        }
        const [ navigation ] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];

        return "back_forward" === navigation?.type;
    }
}

const ResumeUtils = new ResumeUtilsWrapper();

export default ResumeUtils;
